function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/* eslint-disable no-empty-function */
import Player from '@vimeo/player';
import autoBind from 'auto-bind';
import 'js-loading-overlay';
import { ajaxifyCart } from '../vendor/ajaxifycart';
import { fetchShopifyCart } from '../biotrust/common/hooks/useShopifyCart';
import { trackAddToCartEvent, trackersPush } from '../biotrust/trackers/utils';
import { AjaxCartAdapter } from '../biotrust/trackers/adapater/cart/ajaxCartAdapter';
import '../../styles/templates/product.scss';
var LOCALSTORAGE_PRECHECKOUT_DISPLAYING = 'bt.preCheckoutUpsell.open';
export var BiotrustProductSection = /*#__PURE__*/function () {
  function BiotrustProductSection(container) {
    _classCallCheck(this, BiotrustProductSection);

    this.$container = $(container);
    this.id = this.$container.data('section-id');
    this.type = this.$container.data('section-type');
    this.hasVimeo = this.$container.data('has-vimeo') === true;
    this.isVip = this.$container.data('is-vip') === true;
    this.isOneThreeSix = this.$container.data('is-1-3-6') === true;
    this.isOneThreeSixFlavor = this.$container.data('is-1-3-6-flavor') === true;
    autoBind(this);

    this._init();
  }

  _createClass(BiotrustProductSection, [{
    key: "onUnload",
    value: function onUnload() {}
  }, {
    key: "onSelect",
    value: function onSelect() {}
  }, {
    key: "onDeselect",
    value: function onDeselect() {}
  }, {
    key: "_setupOneThreeSix",
    value: function _setupOneThreeSix() {
      var _this = this;

      // note, variant id is defined two different ways in this function - one way for the tracking event and one way for the cart post
      // for tracking purposes we always want to send the variant id of the "main" product, not the sns
      // this is because the objective is to match what's in the catalog / feed, which contains only the "main" product ids, not the sns ones
      // however, when adding the product to the cart, we obviously want to send the specific variant the customer chose, ie sns or one time
      var options = [{
        buttonSelector: '#AddtoCart6, #qty-selector-onetime6',
        quantity: 6
      }, {
        buttonSelector: '#AddtoCart3, #qty-selector-onetime3',
        quantity: 3
      }, {
        buttonSelector: '#AddtoCart1, #qty-selector-onetime1',
        quantity: 1
      }, {
        buttonSelector: '#qty-selector-autodeliver6, #qty-selector-autodeliver6-mobile',
        quantity: 6,
        sns: true
      }, {
        buttonSelector: '#qty-selector-autodeliver3, #qty-selector-autodeliver3-mobile',
        quantity: 3,
        sns: true
      }, {
        buttonSelector: '#qty-selector-autodeliver1, #qty-selector-autodeliver1-mobile',
        quantity: 1,
        sns: true
      }];

      if (this.productData.available) {
        var _window$bt = window.bt,
            _window$bt$customer = _window$bt.customer;
        _window$bt$customer = _window$bt$customer === void 0 ? {} : _window$bt$customer;
        var _window$bt$customer$t = _window$bt$customer.tags,
            tags = _window$bt$customer$t === void 0 ? {} : _window$bt$customer$t,
            _window$bt$settings = _window$bt.settings;
        _window$bt$settings = _window$bt$settings === void 0 ? {} : _window$bt$settings;
        var _window$bt$settings$c = _window$bt$settings.checkout;
        _window$bt$settings$c = _window$bt$settings$c === void 0 ? {} : _window$bt$settings$c;
        var _window$bt$settings$c2 = _window$bt$settings$c.freeGifts,
            freeGifts = _window$bt$settings$c2 === void 0 ? [] : _window$bt$settings$c2;
        options.forEach(function (opt) {
          var $el = $(opt.buttonSelector);
          $el.on('click keydown', function (evt) {
            var _window$btDataLayer, _window$btDataLayer2;

            if (evt.type === 'keydown' && evt.which !== 13) {
              return;
            }

            _this._showLoadingOverlay(); // Assumes a single variant


            var _this$productData$var = _slicedToArray(_this.productData.variants, 1),
                _this$productData$var2 = _this$productData$var[0],
                variant = _this$productData$var2 === void 0 ? {} : _this$productData$var2;

            var cartItem = {
              id: variant.id,
              quantity: opt.quantity,
              properties: {
                _cpSessionId: ((_window$btDataLayer = window.btDataLayer) === null || _window$btDataLayer === void 0 ? void 0 : _window$btDataLayer.sessionId) || 'trackers-not-yet-initialized',
                _cpAgentId: ((_window$btDataLayer2 = window.btDataLayer) === null || _window$btDataLayer2 === void 0 ? void 0 : _window$btDataLayer2.agentId) || 'trackers-not-yet-initialized'
              }
            }; // for sns, include the subscription selling plan id

            if (opt.sns) {
              var _$el$get, _$el$get$dataset;

              var sellingPlanId = (_$el$get = $el.get(0)) === null || _$el$get === void 0 ? void 0 : (_$el$get$dataset = _$el$get.dataset) === null || _$el$get$dataset === void 0 ? void 0 : _$el$get$dataset.sellingPlanId;

              if (sellingPlanId) {
                // eslint-disable-next-line camelcase
                cartItem.selling_plan = sellingPlanId; // add selling plan id as line item property for tracking purposes on the post-purchase checkout page.
                //  prefix with underscore to hide from customer on checkout page

                cartItem.properties = _objectSpread(_objectSpread({}, cartItem.properties), {}, {
                  _sellingPlanId: sellingPlanId
                });
              } else {
                // specific catchJS format for error to show in their "Errors" dashboard, rather than "Logs"
                console.error('ERROR', "SNS selling plan is missing for product handle: ".concat(_this.productData.handle, " and variant id: ").concat(variant.id));
              }
            }

            var cartItems = [];

            if (!tags.includes('Employee') && !tags.includes('Affiliate')) {
              freeGifts.forEach(function (item) {
                if (!window.bt.product.inCart.items.find(function (i) {
                  return i.variant_id === Number(item);
                })) {
                  cartItems.push({
                    id: Number(item),
                    quantity: 1
                  });
                }
              });
            } // add the main product last so that it shows up first in the cart


            cartItems.push(cartItem);

            _this._postAddToCart({
              items: cartItems
            }, {
              items: [variant]
            });
          });
        });
      } else {
        options.forEach(function (opt) {
          return $(opt.buttonSelector).attr('disabled', 'disabled');
        });
      }
    }
  }, {
    key: "_postAddToCart",
    value: function _postAddToCart(cartItemsToAdd, trackerPayload) {
      $.post({
        url: '/cart/add.js',
        data: cartItemsToAdd,
        dataType: 'json',
        complete: function () {
          var _complete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var addToCartComplete, success;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    addToCartComplete = new Promise( /*#__PURE__*/function () {
                      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
                        var cart;
                        return regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                setTimeout(function () {
                                  return resolve(false);
                                }, 2000);
                                _context.prev = 1;
                                _context.next = 4;
                                return fetchShopifyCart();

                              case 4:
                                cart = _context.sent;
                                _context.next = 10;
                                break;

                              case 7:
                                _context.prev = 7;
                                _context.t0 = _context["catch"](1);
                                console.error('Failed to fetch cart for AddToCart tracking', _context.t0);

                              case 10:
                                trackAddToCartEvent(new AjaxCartAdapter(trackerPayload.items, cart)); // 300ms - time to let Klaviyo event fire

                                setTimeout(function () {
                                  return resolve(true);
                                }, 300);

                              case 12:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee, null, [[1, 7]]);
                      }));

                      return function (_x) {
                        return _ref.apply(this, arguments);
                      };
                    }());
                    _context2.next = 3;
                    return addToCartComplete;

                  case 3:
                    success = _context2.sent;

                    if (success) {
                      console.log('Trackers AddToCart call complete');
                    } else {
                      console.error('Trackers AddToCart call timed out');
                    }

                    window.location.pathname = '/cart';

                  case 6:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function complete() {
            return _complete.apply(this, arguments);
          }

          return complete;
        }()
      });
    }
  }, {
    key: "_init",
    value: function _init() {
      var _this2 = this;

      var _window = window,
          _window$bt2 = _window.bt;
      _window$bt2 = _window$bt2 === void 0 ? {} : _window$bt2;
      var _window$bt2$settings$ = _window$bt2.settings.splitTests;
      _window$bt2$settings$ = _window$bt2$settings$ === void 0 ? {} : _window$bt2$settings$;
      var _window$bt2$settings$2 = _window$bt2$settings$.preCheckoutUpsell;
      _window$bt2$settings$2 = _window$bt2$settings$2 === void 0 ? {} : _window$bt2$settings$2;
      var _window$bt2$settings$3 = _window$bt2$settings$2.splitTestVariations,
          preCheckoutUpsellVariants = _window$bt2$settings$3 === void 0 ? {
        'iTdOQWZfTd-sKzaUlxKOzQ': '1'
      } : _window$bt2$settings$3;

      if (!$('#ProductJson-' + this.id).html()) {
        console.warn("[BiotrustProductTemplate] Could not find script element: #ProductJson-".concat(this.id));
        return;
      }

      this.productData = JSON.parse(document.getElementById('ProductJson-' + this.id).innerHTML);
      this.preCheckoutUpsellVariants = preCheckoutUpsellVariants;
      $('.product-single__thumbnails', this.$container).not('.slick-initialized').slick({
        dots: false,
        arrows: true,
        vertical: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        verticalSwiping: true,
        nextArrow: '<i class="fa fa-angle-down"></i>',
        prevArrow: '<i class="fa fa-angle-up"></i>'
      });
      var $mobileImageSlider = $('.product-mobile-images', this.$container).not('.slick-initialized').slick({
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
      $('#mobile-video-link').on('click keydown', function (evt) {
        if (evt.type === 'keydown' && evt.which !== 13) {
          return;
        }

        var videoId = $(this).data('slidevideo');
        $('.product-mobile-images').slick('slickGoTo', videoId);
      });

      if (this.hasVimeo) {
        var mobileIframe = $('#vimeo_product_mobile')[0];
        var player = new Player(mobileIframe);
        $mobileImageSlider.on('afterChange', function () {
          player.pause();
        });

        window.onorientationchange = function () {
          if (_this2.isPreCheckoutUpsellShowing) {
            // we will need to re-open the upsell modal after reloading.
            // there's probably a better way to fix whatever the reload is
            // intended to address, but we'll live with it for now >,<
            // In any case, we set this variable here and un-set it on the cart page
            // (so that hitting the back-button from cart doesn't re-open the upsell)
            window.localStorage.setItem(LOCALSTORAGE_PRECHECKOUT_DISPLAYING, 'true');
          }

          player.pause();
          window.location.reload();
        };
      }

      if (this.isVip) {
        $('button.product-form__cart-submit', this.$container).click(function (evt) {
          evt.preventDefault();
          var $form = $(evt.target).parents('#addtocartform').first();

          if ($form.length) {
            $(evt.target).addClass('disabled').prop('disabled', true);
            var id = parseInt($('#ProductSelect-' + _this2.id).val(), 10);

            var variant = _this2.productData.variants.find(function (vnt) {
              return vnt.id === id;
            });

            var quantity = parseInt($('#quantity', _this2.$container).val(), 10); // price is stored in pennies and divided by 2 because VIP is 50% off

            var discountedPrice = _this2.productData.price / 100.0 / 2;
            window[window.bt.settings.trackersDataLayer].push(function (trackers) {
              // eslint-disable-next-line no-warning-comments
              // TODO: Rework to use AjaxCartAdapter?
              // Unfortunately, the adapter relies on the state of the cart object after the item has been added to it.
              // This is so it can form the URL to rebuild the cart for Klaviyo abandoned cart emails.
              trackers.event('AddToCart', {
                value: discountedPrice * quantity,
                currency: 'USD',
                items: [_objectSpread(_objectSpread({}, variant), {}, {
                  title: _this2.productData.title,
                  variantTitle: variant.title,
                  price: discountedPrice,
                  quantity: quantity
                })],
                source: 'shopify'
              });
            }); // 300ms - time to let Klaviyo event fire

            setTimeout(function () {
              $form.trigger('submit');
            }, 300);
          } else {
            throw new Error('Unable to find the Add to Cart form');
          }
        });
      } else {
        if (this.isOneThreeSix && !this.isOneThreeSixFlavor) {
          this._setupOneThreeSix();
        } else if (this.isOneThreeSixFlavor) {// eslint-disable-next-line no-warning-comments
          // TODO: Launch Flavor Selector HERE
        } else {
          var additionalOptions = {};

          if (window.bt.settings.customer.eOA) {
            additionalOptions.continueShoppingLink = '/collections/associate-order-form';
          }

          ajaxifyCart(_objectSpread({
            onAddedToCart: function onAddedToCart(_ref2, cart) {
              var _ref2$values = _ref2.values;
              _ref2$values = _ref2$values === void 0 ? {} : _ref2$values;
              var _ref2$values$id = _ref2$values.id,
                  addedVariantIds = _ref2$values$id === void 0 ? [] : _ref2$values$id,
                  _ref2$values$quantity = _ref2$values.quantity,
                  addedQtys = _ref2$values$quantity === void 0 ? [] : _ref2$values$quantity;
              var variantQuantities = addedVariantIds.reduce(function (acc, id, idx) {
                acc[id] = parseInt(addedQtys[idx], 10);
                return acc;
              }, {});

              var addedVariants = _this2.productData.variants.filter(function (vnt) {
                return addedVariantIds.map(function (id) {
                  return parseInt(id, 10);
                }).includes(vnt.id);
              });

              var payload = {
                items: addedVariants.map(function (vnt) {
                  return _objectSpread(_objectSpread({}, vnt), {}, {
                    title: _this2.productData.title,
                    variantTitle: vnt.title,
                    price: _this2.productData.price / 100.0,
                    quantity: variantQuantities[vnt.id]
                  });
                })
              };
              trackAddToCartEvent(new AjaxCartAdapter(payload.items, cart));
            }
          }, additionalOptions));
        }

        this._initPreCheckoutUpsell();
      } // Find unavailable variants


      var productVariantsToRemove = this.productData.variants.filter(function (variant) {
        return !variant.available;
      }).map(function (variant) {
        return variant.title;
      }); // remove unavailable variants from the drop-down selector

      if (productVariantsToRemove.length > 0) {
        var $addToCartForm = $('form[action="/cart/add"]');

        if (window.MutationObserver && $addToCartForm.length) {
          var config = {
            childList: true,
            subtree: true
          };
          var observer = new MutationObserver(function () {
            productVariantsToRemove.forEach(function (variantName) {
              $('.single-option-selector option').filter(function () {
                return $(this).val() === variantName;
              }).remove();
            });
            observer.disconnect();
          });
          observer.observe($addToCartForm[0], config);
          $('.single-option-selector').trigger('change');
        }
      }
    }
  }, {
    key: "_initPreCheckoutUpsell",
    value: function _initPreCheckoutUpsell() {
      var _this3 = this;

      var productEnabledForPreCheckoutUpsells = Boolean(this.productData.tags.find(function (tag) {
        return tag === 'PreCheckout_Upsell_SplitTest';
      }));
      console.debug('Product tags', this.productData.tags);
      this.preCheckoutUpsellEnabled = productEnabledForPreCheckoutUpsells;
      this.isPreCheckoutUpsellShowing = window.localStorage.getItem(LOCALSTORAGE_PRECHECKOUT_DISPLAYING) === 'true'; // subscribes to the experiment event, which gives id and variation.
      // When the experiment is on the test path and the current product
      // is enabled for it, the pre-checkout upsell will be enabled.

      trackersPush(function (trk) {
        return trk.subscribe({
          topic: 'experiment',
          handler: function handler(_ref3) {
            var experimentId = _ref3.experimentId,
                experimentVariation = _ref3.experimentVariation;
            console.debug('[PreCheckout Test] Split Test Detected', {
              experimentId: experimentId,
              experimentVariation: experimentVariation
            }); // Allow forcing the test path by setting a localStorage value  key: {experimentId}-{experimentVariation} value: true

            var enabledByOverride = window.localStorage.getItem("".concat(experimentId, "-").concat(experimentVariation)) === 'true';
            var enabledBySplitTest = Boolean(Object.keys(_this3.preCheckoutUpsellVariants).find(function (key) {
              return key === experimentId && parseInt(_this3.preCheckoutUpsellVariants[key], 10) === parseInt(experimentVariation, 10);
            }));
            _this3.preCheckoutUpsellEnabled = productEnabledForPreCheckoutUpsells && (enabledBySplitTest || enabledByOverride);
            console.debug('[PreCheckout Test] state', {
              enabled: _this3.preCheckoutUpsellEnabled,
              productEnabledForPreCheckoutUpsells: productEnabledForPreCheckoutUpsells,
              enabledByOverride: enabledByOverride,
              enabledBySplitTest: enabledBySplitTest,
              splitTestVariants: _this3.preCheckoutUpsellVariants
            });
          }
        });
      });
      $('#AddToCart').click(function () {
        _this3._showLoadingOverlay();

        window.location = '/cart';
      });
    }
  }, {
    key: "_showLoadingOverlay",
    value: function _showLoadingOverlay() {
      window.JsLoadingOverlay.show({
        spinnerIcon: 'ball-pulse',
        spinnerColor: '#2BB34D'
      });
    }
  }]);

  return BiotrustProductSection;
}();